<div class="action">
    <div class="action-media">
        <ng-content class="action-media-object" select="fui-icon"></ng-content>
    </div>
    @if (title) {
        <div class="action-modal">
            <div class="action-modal-window">
                <div class="action-modal-window-content" id="label">
                    {{ title | translate }}
                </div>
            </div>
        </div>
    }
</div>
